module.exports = __webpack_public_path__ + "img/example1.cc92358c.png";